function addLinkListener() {
  const loginLinks = document.querySelectorAll('.member-login-link');
  if (!loginLinks.length) return;

  //add event listener to each link
  loginLinks.forEach(link => {
      link.addEventListener('click', () => {
          sessionStorage.setItem('redirectToCart', 'true');
      });
  });
}

function loginPageAction() {
  const redirect = sessionStorage.getItem('redirectToCart');
  if(redirect) {
    const form = document.getElementById('customer_login');
    if (form) {
      //add hidden input to form for redirection
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'return_to';
      hiddenInput.value = '/cart';
      form.appendChild(hiddenInput);
      sessionStorage.removeItem('redirectToCart');
    } else {
      console.warn('Form with ID "customer_login" not found.');
    }
  }
}



document.addEventListener("DOMContentLoaded", () => {
  addLinkListener();
  loginPageAction();
});
document.addEventListener("cart:updated", function(){
  setTimeout(() => {
    addLinkListener();
  }, 100);
});